<template>
  <el-form
      ref="form"
      :model="form">
    <template v-if="addOpType || editOpType">
      <gj-area-title
          style="margin-bottom: 10px;"
      >产品明细</gj-area-title>
      <div style="margin-bottom: 10px;">
        <gj-button
            type="primary"
            @click="addProduct"
        >添加产品</gj-button>
        <gj-button
            @click="importProduct"
        >导入产品</gj-button>
      </div>
    </template>
    <gj-table
        :index="false"
        name="purchaseOrderAddProduct"
        :data="form.products"
        :columns="columns"
        border
        :loading="loading"
        :auto-resize="false"
        :adapt-height-listen-update="false"
        :show-overflow="false"
        :min-height="400"
        :offset-height="viewOpType ? 208 : 58">
      <template v-slot:sku="{row}">
        <div>
          <gj-text>{{row.productName | defaultShow}}</gj-text>
        </div>
        <div>{{row.sku | defaultShow}}</div>
        <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
      </template>
      <template v-slot:orderQuantity="{index}">
        <el-form-item
            :prop="`products.${index}.orderQuantity`"
            :rules="[
              { required: true, message: '请输入采购量', trigger: ['change'] },
              $gjReRule(RE.pt, '请输入正整数')
            ]"
            class="gj-table-item">
          <gj-input
              v-model="form.products[index].orderQuantity"
              @input="orderQuantityInput(index)"
              width="100%">
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:includeTaxPrice="{index}">
        <el-form-item
            :prop="`products.${index}.includeTaxPrice`"
            :rules="[
              { required: true, message: '请输入含税单价', trigger: ['change'] },
              $gjReRule(RE.num(2), '最多2位小数的正整数')
            ]"
            class="gj-table-item">
          <gj-input
              v-model="form.products[index].includeTaxPrice"
              @input="includeTaxPriceInput(index)"
              width="100%">
            <template #prepend>{{form.products[index].currencySymbol}}</template>
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:amount="{index}">
        {{form.products[index].amount | amount | defaultShow(form.products[index].currencySymbol)}}
      </template>
      <template v-slot:memo="{index}">
        <el-form-item
            :prop="`products.${index}.memo`"
            class="gj-table-item">
          <gj-input
              v-model="form.products[index].memo"
              width="100%"
              placeholder="备注">
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:expectDeliveryDate="{index}">
        <el-form-item
            :prop="`products.${index}.expectDeliveryDate`"
            :rules="[
              { required: true, message: '请选择采购交期', trigger: ['change'] },
            ]"
            class="gj-table-item">
          <gj-date-picker
              v-model="form.products[index].expectDeliveryDate"
              :clearable="false"
              width="120px">
          </gj-date-picker>
        </el-form-item>
      </template>
      <template v-slot:op="{index}">
        <gj-button
            type="text"
            @click="deleteItem(index)">
          删除
        </gj-button>
      </template>
      <template #footer>
        <div v-gutter="20" class="default">
          <span>商品种类数：{{totalProductNum}}</span>
          <span>采购量合计：{{form.products | sum('orderQuantity')}}</span>
          <span>总金额合计：{{form.products | sum('amount') | amount | defaultShow(currencySymbol)}}</span>
        </div>
      </template>
    </gj-table>
  </el-form>
</template>

<script>
  import {OpEnum, ProductEnum} from "@/utils/options";
  import AppAddProductModal from "./add-product-modal";
  import AppImportProductModal from "./import-product-modal";
  import {formDeleteItemMixin, formRuleMixin, opTypeMixin, responseMixin} from "@/minxins";
  import {isMeaningful, isMeaningless, toFixed, unique} from "@/utils/common";
  import {addDays} from 'date-fns';

  export default {
    name: "app-op-purchase-order-product",
    mixins: [formRuleMixin, responseMixin, formDeleteItemMixin, opTypeMixin],
    props: {
      form: {
        required: true
      },
      opType: {
        required: true
      },
      mountTo: {
        required: true
      },
      purchaseOrder: {
        required: true
      }
    },
    data() {
      return {
        loading: false,
        columns: [],
        OpEnum: OpEnum,
        productTypeOption: ProductEnum.typeOption,
      }
    },
    created() {
      this.formItemsName = 'products';
      if (this.addOpType || this.editOpType) {
        this.columns = [
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '250px'},
          {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', width: '70px', align: 'right'},
          {id: 'orderQuantity', header: '采购量', field: 'slot:orderQuantity', required: true, width: '120px'},
          {id: 'includeTaxPrice', header: '含税单价', field: 'slot:includeTaxPrice', required: true, width: '140px'},
          {id: 'amount', header: '金额', field: 'slot:amount', width: '90px', align: 'right'},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '300px'},
          {id: 'expectDeliveryDate', header: '预计交货日期', field: 'slot:expectDeliveryDate', required: true,
            help: '默认值：采购订单创建时间 + 报价中的采购交期。可根据实际情况进行设定。', width: '150px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '50px'},
        ];
      } else if (this.viewOpType) {
        this.columns = [
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '250px'},
          {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', width: '100px', align: 'right'},
          {id: 'orderQuantity', header: '采购量', field: 'orderQuantity', align: 'right', width: '100px'},
          {id: 'includeTaxPrice', header: '含税单价', field: 'includeTaxPrice', prefix: 'currencySymbol', align: 'right', width: '100px'},
          {id: 'amount', header: '金额', field: 'slot:amount', width: '90px', align: 'right'},
          {id: 'memo', header: '备注', field: 'memo', minWidth: '300px'},
          {id: 'expectDeliveryDate', header: '预计交货日期', field: 'expectDeliveryDate', width: '150px'},
        ];
      }
    },
    computed: {
      totalProductNum() {
        return this.form.products.length;
      },
      currencySymbol() {
        if (this.form.products.length > 0) {
          return this.form.products[0].currencySymbol;
        }
        return '';
      }
    },
    methods: {
      orderQuantityInput(index) {
        const orderQuantity = this.form.products[index].orderQuantity;
        if (isMeaningful(orderQuantity)) {
          if (this.RE.pt.test(orderQuantity)) {
            this.setAmount(index);
          } else {
            this.form.products[index].amount = '-';
          }
        } else {
          this.form.products[index].amount = 0;
        }
      },
      includeTaxPriceInput(index) {
        const includeTaxPrice = this.form.products[index].includeTaxPrice;
        if (isMeaningful(includeTaxPrice)) {
          if (this.RE.num(2).test(includeTaxPrice)) {
            this.setAmount(index);
          } else {
            this.form.products[index].amount = '-';
          }
        } else {
          this.form.products[index].amount = 0;
        }
      },
      setAmount(index) {
        const orderQuantity = this.form.products[index].orderQuantity;
        const includeTaxPrice = this.form.products[index].includeTaxPrice;
        this.form.products[index].amount = toFixed(Number(orderQuantity) * Number(includeTaxPrice));
      },
      addProduct() {
        if (!this.canAddProduct()) {
          return;
        }
        this.$gjCreate(AppAddProductModal, {
          mountTo: this.mountTo,
          props: {
            deliveryWarehouseId: this.form.deliveryWarehouseId,
            supplierCode: this.form.supplierCode,
            hideSkuList: this.form.products.map(item => item.sku)
          },
          on: {
            select: (products) => {
              (products || []).forEach(item => item.id = null);
              this.form.products = unique([].concat(this.form.products).concat(products || []), 'sku')
                .map(item => this.mapToItem(item));
            }
          }
        });
      },
      importProduct() {
        if (!this.canAddProduct()) {
          return;
        }
        this.$gjCreate(AppImportProductModal, {
          mountTo: this.mountTo,
          props: {
            deliveryWarehouseId: this.form.deliveryWarehouseId,
            supplierCode: this.form.supplierCode,
          },
          on: {
            importSuccess: (data) => {
              this.updateItems(data);
            },
            importPartSuccess: (data) => {
              this.updateItems(data);
            }
          }
        })
      },
      updateItems(data) {
        if (isMeaningful(data)) {
          data.forEach(newItem => {
            newItem.id = null;
            newItem.tmpIncludeTaxPrice = newItem.includeTaxPrice;
            newItem.includeTaxPrice = null;
            const find = this.form.products.find(oldItem => newItem.sku === oldItem.sku);
            if (find) {
              Object.assign(find, this.mapToItem(newItem));
            } else {
              this.form.products.push(this.mapToItem(newItem));
            }
          });
        }
      },
      mapToItem(item) {
        return {
          ...item,
          smallImageUrl: item.smallImageUrl,
          productName: item.productName,
          sku: item.sku,
          productType: item.productType,
          categoryName: item.categoryName,
          singleQuantity: item.singleQuantity,
          orderQuantity: item.orderQuantity || null,
          includeTaxPrice: item.includeTaxPrice || item.tmpIncludeTaxPrice || null,
          amount: item.amount || null,
          memo: item.memo || null,
          expectDeliveryDate: item.expectDeliveryDate || addDays(new Date(), item.purchaseDeliveryDays || 0),
          currency: item.currency,
          currencySymbol: item.currencySymbol
        };
      },
      canAddProduct() {
        if (isMeaningless(this.form.deliveryWarehouseId)) {
          this.$gjMessage.error('请先选择采购仓');
          return false;
        }
        if (isMeaningless(this.form.supplierCode)) {
          this.$gjMessage.error('请先选择供应商');
          return false;
        }
        return true;
      },
      formValidate() {
        if (this.form.products.length === 0) {
          this.$gjMessage.error('请添加产品');
          return false;
        }
        return this.$gjFormValidate();
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
